/**
 * @module components/AlertError
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React from 'react';
import { Alert } from 'react-bootstrap';

import { useLanguageState } from '../contexts/LanguageProvider';

const AlertError = () => {
  const [ lang ] = useLanguageState();
  return (
    <Alert bsStyle='danger'>
      <p><strong>{lang.error}</strong> {lang.errorDetails}</p>
    </Alert>
  );
}

export default AlertError;